import { Component, OnInit, Output, EventEmitter, Input, forwardRef, NgZone } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'color-picker',
  templateUrl: './color-picker.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorPickerComponent),
      multi: true
    }
  ]
})

export class ColorPickerComponent extends BaseTranslation implements OnInit, ControlValueAccessor {
  color: string = '#ffffff';
  okText: string;
  cancelText: string;
    // Allow the input to be disabled.
  @Input() disabled = false;

  constructor(translate: TranslateService, ngZone: NgZone) {
    super(translate, ngZone);
    this.translate.get('common').subscribe((res) => {
      this.okText = res["Confirm"];
      this.cancelText = res["cancel"];
    });
  }

  ngOnInit() {}

  onColorChange() {
    this.pick(this.color);
  }

  // Function to call when the people changes.
  onChange = (color: string) => { };

  // Function to call when the input is touched.
  onTouched = () => { };

  get value(): string {
    return this.color;
  }

  pick(color: string) {
    if (!this.disabled) {
      this.writeValue(color);
    }
  }


  // Allows Angular to update the model.
  // Update the model and changes needed for the view here.
  writeValue(color: string): void {
    this.color = color;
    this.onChange(this.value)
  }

  // Allows Angular to register a function to call when the model changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: (color: string) => void): void {
    this.onChange = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Allows Angular to disable the input.
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}

// Reference
// https://www.npmjs.com/package/ngx-color-picker